import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowOutOfBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowOutOfBox"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2.68945L17.5607 8.25011L16.5 9.31077L12.75 5.56077V15.7501H11.25V5.56078L7.5 9.31077L6.43934 8.25011L12 2.68945Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 14.0001V19.5001H19.5V14.0001H21V21.0001H3V14.0001H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowOutOfBox;
